/* eslint-disable prettier/prettier */
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AdjustIcon from "@mui/icons-material/Adjust";
import ArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import CloudDonwloadIcon from "@mui/icons-material/CloudDownload";
import ComputerIcon from "@mui/icons-material/Computer";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import FolderIcon from "@mui/icons-material/Folder";
import FullScreenIcon from "@mui/icons-material/Fullscreen";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import LibraryBooks from "@mui/icons-material/LibraryBooks";
import RedoIcon from "@mui/icons-material/Redo";
import RemoveIcon from "@mui/icons-material/Remove";
import SaveIcon from "@mui/icons-material/Save";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import SendIcon from "@mui/icons-material/Send";
import UndoIcon from "@mui/icons-material/Undo";
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";

import { BpmDeployModal } from "./bpm-deploy-modal";
import BpmSelectProcess from "./BpmSelectProcess";
import SelectDraftModal from "./modals/draftListModal";
import { emptyBpmn } from "../../../assets/empty.bpmn";
import {
  MODELER,
  VIEW,
  DOWNLOAD,
  NEW,
  DRAFT_EDIT,
  DRAFT_DELETE,
} from "../../../constants/modules";
import { useProcessDefinitionDeploy } from "../../../hooks/deployments";
import {
  useProcessDefinitionDraftCreate,
  useProcessDefinitionDraftDelete,
  useProcessDefinitionDraftFindByProcessKey,
  useProcessDefinitionDraftUpdate,
  useProcessDefinitionsDraftDownload,
} from "../../../hooks/drafts";
import {
  useProcessDefinition,
  useProcessDefinitionVersions,
} from "../../../hooks/process_definitions";
import { language } from "../../../language";
import { ConfirmModal } from "../../modal/simple-confirm-modal";
import PermissionContainer from "../../PermissionContainer";
import { SimpleSnackbarContext } from "../../SimpleSnackbar";

const BpmnControls = (props) => {
  const {
    onSaveFile,
    onSaveImage,
    modeler,
    onUndo,
    onRedo,
    onfullscreen,
    onZoomIn,
    onZoomOut,
    onZoomReset,
    onShowHidePropertiesPanel,
    findErrorInProcess,
  } = props;
  const { actions: snackActions } = useContext(SimpleSnackbarContext);
  const [openModal, setOpenModal] = useState(false);
  const [openSelectProcess, setOpenSelectProcess] = useState(false);
  const [openSelectDraft, setOpenSelectDraft] = useState(false);
  const [openDeleteDraftModal, setOpenDeleteDraftModal] = useState(false);
  const [openSaveDraftModal, setOpenSaveDraftModal] = useState(false);
  const [selectVersion, setSelectVersion] = useState(null);
  const [processID, setProcessID] = useState(null);
  const [processKey, setProcessKey] = useState(null);
  const [draftId, setDraftId] = useState(null);

  const uploadRef = useRef(null);

  const { mutate: deleteProcessDefinitionDraft } =
    useProcessDefinitionDraftDelete({
      params: {},
    });

  const { data: draftXml, refetch: fetchDraftXml } =
    useProcessDefinitionsDraftDownload({
      id: draftId,
      enabled: false,
    });

  const { mutate: processDeploy } = useProcessDefinitionDeploy();

  const { refetch: fetchProcessDeployment, data: processDeployment } =
    useProcessDefinition({
      enabled: false,
      id: processID,
    });

  const { refetch: fetchProcessDefinitionVersions, data: versionList } =
    useProcessDefinitionVersions({
      enabled: false,
      key: processKey,
      params: {
        isPageable: false,
        sort: "version",
        sortOrder: "desc",
        key: processKey,
      },
    });

  const { mutate: updateDraft } = useProcessDefinitionDraftUpdate();

  const { mutate: createDraft } = useProcessDefinitionDraftCreate();

  const { mutateAsync: findDraftByProcessKey } =
    useProcessDefinitionDraftFindByProcessKey();

  const openBpmnDiagram = useCallback(
    (xml) => {
      if (!modeler) return;
      try {
        modeler.importXML(xml).then(() => {
          const canvas = modeler.get("canvas");
          canvas.zoom("fit-viewport");
        });
      } catch (err) {
        console.error(err.message, err.warnings);
      }
    },
    [modeler],
  );

  useEffect(() => {
    if (draftId) fetchDraftXml();
  }, [draftId, fetchDraftXml]);

  useEffect(() => {
    if (draftXml) openBpmnDiagram(draftXml);
  }, [draftXml, openBpmnDiagram]);

  useEffect(() => {
    if (!processKey) return;
    fetchProcessDefinitionVersions();
  }, [processKey, fetchProcessDefinitionVersions]);

  useEffect(() => {
    if (!processID) return;
    fetchProcessDeployment();
  }, [processID, fetchProcessDeployment]);

  useEffect(() => {
    if (!processDeployment) return;
    openBpmnDiagram(processDeployment.bpmn20Xml);
  }, [processDeployment, openBpmnDiagram]);

  const onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      const xml = reader.result;
      setSelectVersion(null);
      setDraftId(null);
      openBpmnDiagram(xml);
    };
    reader.readAsText(file);
    event.target.value = "";
  };

  const handleCreate = () => {
    setSelectVersion(null);
    setDraftId(null);
    openBpmnDiagram(emptyBpmn);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // --- draft
  const handleOpenSaveDraftModal = () => setOpenSaveDraftModal(true);
  const handleCloseSaveDraftModal = () => setOpenSaveDraftModal(false);
  const handleOpenDeleteDraftModal = () => setOpenDeleteDraftModal(true);

  const changeVersionModel = (id, version) => {
    setProcessID(id);
    setSelectVersion(version);
  };

  // carrega o xml e todas as versões do processo selecionado
  const loadProcessDefinition = async (process) => {
    const { id, version, key } = process;

    setProcessID(id);
    setSelectVersion(version);
    setProcessKey(key);
    setOpenSelectProcess(false);
    setDraftId(null);
  };

  return (
    <div className="io-import-export">
      <ul className="io-import io-control io-control-list io-horizontal">
        <li className="dropdown">
          <input
            id="myInput"
            type="file"
            ref={uploadRef}
            style={{ display: "none" }}
            onChange={onChangeFile}
          />

          <button className="dropbtn">
            <FolderIcon />
          </button>
          <div className="dropdown-content">
            <button
              onClick={() => {
                uploadRef.current?.click();
              }}
            >
              <ComputerIcon /> {language.openLocalButton}
            </button>
            <PermissionContainer permission={MODELER + VIEW} returnNull>
              <button onClick={() => setOpenSelectProcess(true)}>
                <CloudDonwloadIcon /> {language.openServerButton}
              </button>
            </PermissionContainer>
            <PermissionContainer permission={MODELER + VIEW} returnNull>
              <button
                data-cy="draftListTable"
                onClick={() => setOpenSelectDraft(true)}
              >
                <LibraryBooks /> {language.openDrafts}
              </button>
            </PermissionContainer>
          </div>
        </li>
        <li className="vr" style={{ marginLeft: "2px" }} />
        <li>
          <button title={language.createButton} onClick={handleCreate}>
            <AddCircleIcon />
          </button>
        </li>
      </ul>
      <PermissionContainer returnNull permission={MODELER + DOWNLOAD}>
        <ul className="io-import io-control io-control-list io-horizontal">
          <li>
            <a
              onClick={onSaveFile}
              target="_blank"
              rel="noopener noreferrer"
              href="/#"
              className="download"
              title={language.downloadBpm}
              jswidget="downloadBPMN"
              data-track="diagram:download-bpmn"
              download="diagram.bpmn"
            >
              <SaveAltIcon />
            </a>
          </li>
          <li className="vr" style={{ marginLeft: "2px" }} />
          <li>
            <a
              onClick={onSaveImage}
              target="_blank"
              rel="noopener noreferrer"
              href="/#"
              className="download"
              title={language.downloadSvg}
              jswidget="downloadSVG"
              data-track="diagram:download-svg"
            >
              <InsertPhotoIcon />
            </a>
          </li>
        </ul>
      </PermissionContainer>

      <ul className="io-import io-control io-control-list io-horizontal">
        <li>
          <button title={language.undoButton} onClick={onUndo}>
            <UndoIcon />
          </button>
        </li>
        <li className="vr" style={{ marginLeft: "2px" }} />
        <li>
          <button title={language.redoButton} onClick={onRedo}>
            <RedoIcon />
          </button>
        </li>
      </ul>
      <ul className="io-import io-control io-control-list io-horizontal">
        <li>
          <button title={language.resetButton} onClick={onZoomReset}>
            <AdjustIcon />
          </button>
        </li>
        <li className="vr" style={{ marginLeft: "2px" }} />
        <li>
          <button title={language.zoomInButton} onClick={onZoomIn}>
            <AddIcon />
          </button>
        </li>
        <li className="vr" style={{ marginLeft: "2px" }} />
        <li>
          <button title={language.zoomOutButton} onClick={onZoomOut}>
            <RemoveIcon />
          </button>
        </li>
      </ul>
      {versionList && selectVersion && (
        <ul className="io-import io-control io-control-list io-horizontal">
          <li className="dropdown">
            <button className="dropbtn">
              {`Versão: ${selectVersion}`} <ArrowDownIcon />
            </button>
            <div className="dropdown-content">
              {versionList?.content?.map((p) => (
                <button
                  key={p.id}
                  onClick={() => {
                    changeVersionModel(p.id, p.version);
                  }}
                >{`ver ${p.version}`}</button>
              ))}
            </div>
          </li>
        </ul>
      )}
      <ul className="io-import io-control io-control-list io-horizontal">
        <li>
          <button title={language.fullScreenButton} onClick={onfullscreen}>
            <FullScreenIcon />
          </button>
        </li>
      </ul>
      <PermissionContainer permission={MODELER + NEW} returnNull>
        <ul className="io-import io-control io-control-list io-horizontal">
          <li>
            <button title={language.deployButton} onClick={handleOpenModal}>
              <SendIcon />
            </button>
          </li>
        </ul>
      </PermissionContainer>

      <ul className="io-import io-control io-control-list io-horizontal">
        <PermissionContainer permission={MODELER + DRAFT_EDIT} returnNull>
          <li>
            <button title={language.saveDraft} onClick={handleOpenSaveDraftModal}>
              <SaveIcon />
            </button>
          </li>
        </PermissionContainer>
        {draftId && (
          <PermissionContainer permission={MODELER + DRAFT_DELETE} returnNull>
            <li className="vr" style={{ marginLeft: "2px" }} />
            <li>
              <button
                title={language.deleteDraft}
                onClick={handleOpenDeleteDraftModal}
              >
                <DeleteRoundedIcon />
              </button>
            </li>
          </PermissionContainer>
        )}
      </ul>

      <ul className="io-import io-control io-control-list io-horizontal">
        <li>
          <button
            title={language.show_hide_properties_panel}
            onClick={onShowHidePropertiesPanel}
          >
            &#9776;
          </button>
        </li>
      </ul>
      <BpmDeployModal
        openDialog={openModal}
        saveModel={() => {
          modeler.saveXML({ format: true }, (err, xml) => {
            const isValidProcess = findErrorInProcess();
            if (!isValidProcess.isValid) {
              snackActions.open(isValidProcess.Error, { severity: "error" });
              return;
            }

            let fKeys = "";
            const folderIds = [];
            const templateIds = [];

            const defs = modeler.getDefinitions();
            defs.rootElements.forEach((element) => {
              if (element.$type === "bpmn:Process") {
                element &&
                  element.flowElements &&
                  element.flowElements.forEach((flowElement) => {
                    if (
                      Object.prototype.hasOwnProperty.call(
                        flowElement,
                        "formKey",
                      )
                    ) {
                      fKeys += (fKeys ? ", " : "") + flowElement.formKey;
                    }

                    if (
                      Object.prototype.hasOwnProperty.call(
                        flowElement,
                        "extensionElements",
                      ) &&
                      Object.prototype.hasOwnProperty.call(
                        flowElement.extensionElements,
                        "values",
                      )
                    ) {
                      flowElement.extensionElements.values.forEach((value) => {
                        if (
                          Object.prototype.hasOwnProperty.call(
                            value,
                            "inputParameters",
                          )
                        ) {
                          value.inputParameters.forEach((parameter) => {
                            if (parameter.name === "parentFolder") {
                              folderIds.push({ id: parameter.value });
                            }

                            if (parameter.name === "template") {
                              templateIds.push({ id: parameter.value });
                            }
                          });
                        }
                      });
                    }
                  });
              }
            });

            const formsAndKeys = [];

            if (fKeys) {
              fKeys = fKeys ? fKeys.replace(/ /g, "").split(",") : [];
              fKeys.forEach((formD) => {
                const formId = formD.substring(0, formD.lastIndexOf("_"));
                const formUnformatedVersion = formD.substring(
                  formD.lastIndexOf("_") + 1,
                );

                const resultExp = formUnformatedVersion.replace(/[\D]/g, ""); //expressaoRegular.exec(formUnformatedVersion);

                if (resultExp !== null) {
                  formsAndKeys.push({
                    formId,
                    version: formUnformatedVersion.substring(1),
                  });
                }
              });
            }

            const process = defs.rootElements.find(
              (el) => el.$type === "bpmn:Process",
            );
            const filename = `${process.name}.bpmn`;

            const file = new File([xml], filename + ".bpmn", {
              type: "",
            });
            processDeploy(
              {
                file,
                filename: filename + ".bpmn",
                formsKeys: JSON.stringify(formsAndKeys),
                foldersIds: JSON.stringify(folderIds),
                templatesIds: JSON.stringify(templateIds),
              },
              {
                onSuccess: (response) => {
                  fetchProcessDefinitionVersions();
                  const defition = Object.keys(
                    response.deployedProcessDefinitions || {},
                  )[0];
                  setSelectVersion(
                    response.deployedProcessDefinitions[defition].version,
                  );
                  setProcessID(defition);
                },
              },
            );
          });
        }}
        handleDialogClose={handleCloseModal}
      />

      {openSelectProcess && (
        <BpmSelectProcess
          openDialog={openSelectProcess}
          onSelect={loadProcessDefinition}
          handleCancel={() => {
            setOpenSelectProcess(false);
          }}
        />
      )}

      {openSelectDraft && ( // list draft
        <SelectDraftModal
          openDialog={openSelectDraft}
          handleCancel={() => {
            setOpenSelectDraft(false);
          }}
          onSelectDraft={(id) => {
            setDraftId(id);
            setOpenSelectDraft(false);
            setProcessID(null);
          }}
        />
      )}

      {openSaveDraftModal && ( // save draft
        <ConfirmModal
          title={language.saveDraft}
          textMessage={language.saveDrafQuestion}
          openDialog={openSaveDraftModal}
          handleDialogClose={handleCloseSaveDraftModal}
          handleSubmit={async () => {
            modeler.saveXML({ format: true }, async (_err, xml) => {
              const isValidProcess = findErrorInProcess();
              if (!isValidProcess.isValid) {
                snackActions.open(isValidProcess.Error, { severity: "error" });
                return;
              }

              const defs = modeler.getDefinitions();
              const process = defs.rootElements.find(
                (el) => el.$type === "bpmn:Process",
              );
              const filename = `${process.name}.bpmn`;
              const processKey = process.id;
              const category = process.documentation?.length
                ? process.documentation[0]?.text || ""
                : "";
              const file = new File([xml], filename, { type: "" });

              const payload = { filename, file, processKey, category };
              if (draftId) {
                updateDraft({ id: draftId, payload });
              } else {
                const result = await findDraftByProcessKey({
                  processKey,
                }).catch(() => null);
                const draft = result.content.find(
                  (draft) => draft.processKey === processKey,
                );

                if (draft && draft.id) {
                  updateDraft({ id: draft.id, payload });
                } else {
                  createDraft(payload, {
                    onSuccess: (response) => {
                      setDraftId(response.id);
                    },
                  });
                }
              }
            });
          }}
        />
      )}

      {openDeleteDraftModal && ( // delete draft
        <ConfirmModal
          title={language.deleteDraft}
          textMessage={language.deleteDrafQuestion}
          openDialog={openDeleteDraftModal}
          handleDialogClose={() => setOpenDeleteDraftModal(false)}
          handleSubmit={() => {
            deleteProcessDefinitionDraft(draftId);
            handleCreate();
          }}
        />
      )}
    </div>
  );
};

export default BpmnControls;
